export enum FieldRenderMode {
	TableEdit,
	TableReadonly,
	GridEdit,
	GridReadonly,
	Manage
}
